import React, { Component } from 'react';

import Header from '../header/header.js';
import Footer from '../footer/footer.js';
//import ContactForm from '../support/contactform.js';

import IframeResizer from 'iframe-resizer-react';
import  {Helmet} from "react-helmet";


export default class Einfo extends Component {

	
    



    render() {


      

        return(
            <div>
                 <Helmet>
				<title>{`${ process.env.REACT_APP_NAME } |  E-Info Online Account Services`} </title>	
			
				<meta name="description" content="Pay your bills, view invoices, order supplies and place service calls." />
                </Helmet>
            <Header page_services={true}/>
            
              <div role="main" className="main">
              <div className="row">
                    
                    <div className="col-md-2">
                    </div>
                    <div className="col-md-8">
                        <div className="holds-the-iframe">
                        {process.env.REACT_APP_SITE_CO == "j2b" && 
                            <IframeResizer 
                                heightCalculationMethod="lowestElement"
                                src="https://einfo.j2b.com/"
                                inPageLinks
                            
                                bodyMargin="0px"
                                style={{ width: '0px', minWidth: '100%',border:'0px'}}
                            />
                        }
                        {process.env.REACT_APP_SITE_CO == "j2bsys" && 
                            <IframeResizer 
                            heightCalculationMethod="lowestElement"
                            src="https://einfo.j2bsys.com/"
                            inPageLinks
                        
                            bodyMargin="0px"
                            style={{ width: '0px', minWidth: '100%',border:'0px'}}
                        />

                      }
                        </div>
                    </div>
                    <div className="col-md-2">
                    </div>
                </div>

                </div>
            <Footer />
            </div>
        );
    }

}